<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import { InteractiveContentPictureCounts } from '@/models/index';

export default defineComponent({
  name: 'GalaxyMain',
  data () {
    return {
      count: 0
    };
  },
  created () {
    const imageURL = require('../../assets/thumbnails/notice.png');
    window.scrollTo(0, 0);
    window.parent.postMessage(
      {
        solutoCampaign: {
          title: '通信やテクノロジーにより暮らしが豊かになる情報をお届け!',
          imageUrl: imageURL
        }
      }, '*'
    );
  },
  methods: {
    gotoInteractive () {
      router.push({ path: '0001-sub1' });
    },
    gotoSecondNotification () {
      router.push({ path: '0001-sub2' });
    },
    gotoPage3 () {
      router.push({ path: '0001-sub3' });
    },
    onImgLoad () {
      this.count++;
      if (this.count === InteractiveContentPictureCounts.oldContent) {
        this.$emit('scroll');
        this.$emit('load');
      }
    }
  }
});
</script>

<template>
  <main class="main" id="main">
      <div class="wrap__manual">
        <!-- ファーストビューエリア-->
        <section class="header__manual">
          <div class="section_inner__manual">
            <h1 class="ttl__manual">通信やテクノロジーにより暮らしが豊かになる情報をお届け!</h1>
            <figure><img class="img__header__manual"  @load="onImgLoad" src="../../assets/recommendation/manual-01_kv.gif" alt=""/></figure>
            <p class="text__manual">【使い方サポート】をご利用いただきありがとうございます。お知らせで届くコンテンツには、あなたの興味に合ったヒントが数多く登場し、暮らしをサポートしていきます。その内容やお伝えする方法もさまざまにご用意。</p>
          </div>
        </section>
        <!-- End ファーストビューエリア-->
        <div class="section_wrapper__manual">
          <!-- コンテンツ 1-->
          <section class="section__manual section__list__manual section__list__manual--purple">
            <figure><img class="img__manual" @load="onImgLoad" src="../../assets/recommendation/manual-01_img1.png" alt=""/></figure>
            <div class="contents__manual">
              <h2 class="ttl__section___manual">上手にスマホで撮影するなら基本の写真テク「三分割法」</h2>
              <p class="text__manual">被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。</p>
              <p>
                <a class="btn__manual" @click="gotoInteractive()">記事を読む</a>
              </p>
            </div>
          </section>
          <!-- End コンテンツ 1-->
          <section class="section__manual section__list__manual section__list__manual--orange">
            <figure><img class="img__manual" @load="onImgLoad" src="../../assets/recommendation/manual-01-galaxy_img2.png"/></figure>
            <div class="contents__manual">
              <h2 class="ttl__section___manual">素敵な写真を残す日々へ…「Galaxy S20 5G SCG01」のある日常</h2>
              <p class="text__manual">日々の暮らしの中にあるさまざまなシーン。そんな日常を写真や動画で簡単、きれいに残してくれるスマートフォンが「Galaxy S20 5G SCG01」。この1台を上手に使うことであなたの毎日が変わる可能性があります。</p>
              <p>
                <a class="btn__manual" @click="gotoSecondNotification()">記事を読む</a>
              </p>
            </div>
          </section>

          <section class="section__manual section__list__manual section__list__manual--green">
            <figure><img class="img__manual has-bgcolor" @load="onImgLoad" src="../../assets/recommendation/manual-01_img3.png"/></figure>
            <div class="contents__manual">
              <h2 class="ttl__section___manual">スマホが医療機関との距離を近づける「オンライン診療」とは？</h2>
              <p class="text__manual">スマートフォンはWEBを通じてさまざまな世界と簡単につながり、生活のお困りごとを解消してくれるのが便利なポイント！体調が少し悪いかな…というとき、おうち時間でお医者さんのオンライン診療を受けられるアプリサービスもあります。</p>
              <p>
                <a class="btn__manual" @click="gotoPage3()">記事を読む</a>
              </p>
            </div>
          </section>
        </div>
        <section class="footer__manual">
          <div class="section_inner__manual">
            <h2 class="ttl__manual">スマホの楽しさ、もっと広がる。</h2>
            <p>このように、これから始まる新しいスマートフォンとの生活をより楽しく、より快適にしてくれるヒントをさまざまな記事でご紹介していきます。【使い方サポート】がお届けするコンテンツの代表例をはじめ、あなたの暮らしがより快適になる今後の出会いにご期待ください。</p>
          </div>
        </section>
      </div>
    </main>
</template>

<style lang="scss" scoped>
@import "@/styles/manual_notice.scss";
</style>
